/** TanStack Query keys: invalidating a key refreshes every view that shows that data. */
export const queryKeys = {
  users: ['users'] as const,
  profiles: ['profiles'] as const,
  backups: ['backups'] as const,
  auditEvents: ['audit-events'] as const,
  companyRoles: ['organization', 'roles'] as const,
};
